export const appSliderRightIcon = {
    data: `<svg viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.790039 32.43L2.57004 34.26L19.21 17.13L2.57004 0L0.790039 1.83L15.62 17.13L0.790039 32.43Z" fill="#4F4F4F"/></svg>`,
    name: 'slider-right'
};